import { render, staticRenderFns } from "./productsPage.vue?vue&type=template&id=27699300&scoped=true"
import script from "./productsPage.vue?vue&type=script&lang=js"
export * from "./productsPage.vue?vue&type=script&lang=js"
import style0 from "./productsPage.vue?vue&type=style&index=0&id=27699300&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27699300",
  null
  
)

export default component.exports